<script>
import { euroCouponsThirdpartyMethods } from '@state/helpers'

export default {
  name: 'EuroCouponsThirdpartyDetail',
  components: {},
  props: {
    instanceJson: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    oncomplete: {
      type: Function,
      required: false,
      default: () => ({}),
    },
    oncancel: {
      type: Function,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      modalShow: true,
      loading: true,
      toDetail: {}
    }
  },
  computed: {},

  mounted: function () {
    let context = this
    if (context.instanceJson.url) {
      context.toDetail = {
        ...context.instanceJson,
      }
      context.getObject()
    } else {
      context.oncancel()
    }
  },

  methods: {
    ...euroCouponsThirdpartyMethods,

    getObject() {
      let context = this
      const promise = context.fetchEuroCouponsThirdpartyDetail(context.toDetail.url)
      return promise
        .then((data) => {
          context.toDetail = { ...data }
          context.loading = false
        })
        .catch((error) => {
          context.$axios_error_noty(error, context)
          context.loading = false
          context.oncancel()
        })
    },
  },
}
</script>

<template>
  <b-modal
    v-model="modalShow"
    :title="`${ $t('detail_of') } ${ $t('thirdparty') }`"
    size="lg"
    ok-only
    @hidden="oncancel"
  >
    <b-container class="p-0">
      <b-row v-if="loading">
        <b-col md="12">
          <div class="text-center">
            <b-spinner
              label="Spinning"
              style="color: #195db2; width: 4rem; height: 4rem"
            ></b-spinner>
          </div>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col md="12">
          <table
            v-if="toDetail.url"
            class="table-hover table-sm mb-0 table-responsive"
            style="table-layout: fixed; width: 100%"
          >
            <tr>
              <th style="text-align: right">{{ $t("name") }}</th>
              <td>{{ toDetail.name }}</td>
            </tr>
            <tr>
              <th style="text-align: right">{{ $t("nit") }}</th>
              <td>{{ toDetail.nit }}</td>
            </tr>
            <tr>
              <th style="text-align: right">{{ $t("contact_name") }}</th>
              <td>{{ toDetail.contact_name }}</td>
            </tr>
            <tr>
              <th style="text-align: right">{{ $t("contact_email") }}</th>
              <td>{{ toDetail.contact_email }}</td>
            </tr>
            <tr>
              <th style="text-align: right">{{ $t("payment_due_date") }}</th>
              <td>{{ toDetail.payment_due_date }}</td>
            </tr>
            <tr>
              <th style="text-align: right">{{ $t("prefix_code") }}</th>
              <td>{{ toDetail.prefix_code }}</td>
            </tr>
            <tr>
              <th style="text-align: right">{{ $t("logo") }}</th>
              <td>{{ toDetail.logo }}</td>
            </tr>
          </table>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>
<style lang="scss">
</style>